import { ChangeDetectionStrategy, ChangeDetectorRef, Component, HostBinding, Input, OnInit } from '@angular/core';
import { Team } from '../../../../services/cebl.api.types';
import { WpMenuDataItem } from '@streamamg/amg-common';

@Component({
  selector: 'app-team-box',
  templateUrl: './team-box.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TeamBoxComponent implements OnInit {
  @HostBinding('attr.data-team') teamSlug;
  @HostBinding('class') hostClass = 'team-color-bg';
  @Input() teamsPath: string;
  @Input() team: Team;
  @Input() menuItem: WpMenuDataItem;


  constructor(
    private cd: ChangeDetectorRef,
  ) {
  }

  ngOnInit(): void {

    this.teamSlug = this.team?.wpTeam.post_slug;
    this.cd.detectChanges();
  }

}
